import React from 'react';
import { Box, SxProps } from '@mui/material';

interface ICustomPageHeaderLayout {
    children: React.ReactNode | React.ReactNode[];
    sx?: SxProps;
}

export function DBlock(props: ICustomPageHeaderLayout) {
    const { children, sx } = props;
    return (
        <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', minHeight: 0, ...sx }}>
            {children}
        </Box>
    );
}
